'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var PromptablePropInterface = {
  onConfirm: _react.PropTypes.func.isRequired,
  onReject: _react.PropTypes.func.isRequired
};

exports.default = PromptablePropInterface;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/decorators/PromptablePropInterface.js
// module id = 163
// module chunks = 0